export default __webpack_public_path__ + "images/sweep5.f4c52e1bdfd894a07affcfb9ccec6e6c.png";